(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-quote"] && !Shopify.designMode) return;
  try {
    
  const PA_QUOTE_REF_PARAMS = ['ref', 'product', 'sku'];
  const PA_QUOTE_MAX_FILE_BYTES = 10 * 1024 * 1024;

  function initQuoteFile(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const input = root.querySelector('[data-file-input]');
    const empty = root.querySelector('[data-empty]');
    const filled = root.querySelector('[data-filled]');
    const filename = root.querySelector('[data-filename]');
    const clear = root.querySelector('[data-clear]');
    const status = root.querySelector('[data-file-status]');
    const errorType = root.dataset.errorType || '';
    const errorSize = root.dataset.errorSize || '';

    if (!input) return;

    const setStatus = (message, isError) => {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    };

    const reset = () => {
      input.value = '';
      input.removeAttribute('aria-invalid');
      if (empty) empty.hidden = false;
      if (filled) filled.hidden = true;
      if (filename) filename.textContent = '';
      setStatus('', false);
    };

    const reject = (message) => {
      reset();
      input.setAttribute('aria-invalid', 'true');
      setStatus(message, true);
    };

    const applyFile = async (file) => {
      if (!file) {
        reset();
        return;
      }
      if (!/\.pdf$/i.test(file.name) && file.type !== 'application/pdf') {
        reject(errorType);
        return;
      }
      if (file.size > PA_QUOTE_MAX_FILE_BYTES) {
        reject(errorSize);
        return;
      }
      const header = await file.slice(0, 5).arrayBuffer();
      if (!String.fromCharCode(...new Uint8Array(header)).startsWith('%PDF')) {
        reject(errorType);
        return;
      }
      if (filename) filename.textContent = file.name;
      if (empty) empty.hidden = true;
      if (filled) filled.hidden = false;
      setStatus(root.dataset.note || '', false);
    };

    input.addEventListener('change', () => applyFile(input.files && input.files[0]));

    const hasFiles = (event) =>
      Boolean(event.dataTransfer && Array.from(event.dataTransfer.types || []).includes('Files'));

    root.addEventListener('dragover', (event) => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      root.classList.add('is-dragover');
    });

    root.addEventListener('dragleave', (event) => {
      if (root.contains(event.relatedTarget)) return;
      root.classList.remove('is-dragover');
    });

    root.addEventListener('drop', (event) => {
      if (!hasFiles(event)) return;
      event.preventDefault();
      root.classList.remove('is-dragover');
      const file = event.dataTransfer.files[0];
      if (!file) return;
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      applyFile(file);
    });

    if (clear) {
      clear.addEventListener('click', () => {
        reset();
        input.focus();
      });
    }

    if (input.form) input.form.addEventListener('reset', () => setTimeout(reset));
  }

  function initQuote(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const form = root.querySelector('form');
    if (!form) return;

    const radios = Array.from(root.querySelectorAll('[data-type-handle]'));
    const quantityField = root.querySelector('[data-field="quantity"]');
    const quantityInput = quantityField && quantityField.querySelector('input');
    const quantityLabel = root.querySelector('[data-target="quantity-label"]');
    const detailsLabel = root.querySelector('[data-target="details-label"]');
    const detailsInput = root.querySelector('[data-details-input]');
    const ref = root.querySelector('[data-ref]');
    const refValue = root.querySelector('[data-ref-value]');
    const refInput = root.querySelector('[data-ref-input]');
    const refClear = root.querySelector('[data-ref-clear]');

    const applyType = (radio) => {
      if (!radio) return;
      const data = radio.dataset;
      const showQuantity = data.showQuantity === 'true';
      if (quantityField) quantityField.hidden = !showQuantity;
      if (quantityInput) quantityInput.disabled = !showQuantity;
      if (quantityLabel && data.quantityLabel) quantityLabel.textContent = data.quantityLabel;
      if (detailsLabel && data.detailsLabel) detailsLabel.textContent = data.detailsLabel;
      if (detailsInput && data.detailsPlaceholder) detailsInput.placeholder = data.detailsPlaceholder;
    };

    const selectType = (handle) => {
      if (!handle) return;
      const radio = radios.find((item) => item.dataset.typeHandle === handle.toLowerCase());
      if (!radio) return;
      radio.checked = true;
      applyType(radio);
    };

    const setReference = (value) => {
      if (!ref || !refInput) return;
      const text = (value || '').trim().slice(0, 200);
      ref.hidden = !text;
      refInput.disabled = !text;
      refInput.value = text;
      if (refValue) refValue.textContent = text;
    };

    const updateUrl = (mutate) => {
      if (window.Shopify && window.Shopify.designMode) return;
      const url = new URL(window.location.href);
      mutate(url.searchParams);
      window.history.replaceState(window.history.state, '', url);
    };

    const params = new URLSearchParams(window.location.search);
    selectType(params.get('type'));
    setReference(PA_QUOTE_REF_PARAMS.map((key) => params.get(key)).find(Boolean));
    if (quantityInput && params.get('qty') && !quantityInput.value) {
      quantityInput.value = params.get('qty').slice(0, 20);
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        applyType(radio);
        updateUrl((search) => search.set('type', radio.dataset.typeHandle));
      });
    });

    if (refClear) {
      refClear.addEventListener('click', () => {
        setReference('');
        updateUrl((search) => PA_QUOTE_REF_PARAMS.forEach((key) => search.delete(key)));
        if (detailsInput) detailsInput.focus();
      });
    }

    form.addEventListener('reset', () => {
      const reference = refInput && !refInput.disabled ? refInput.value : '';
      const checked = radios.find((radio) => radio.checked);
      setTimeout(() => {
        if (checked) {
          checked.checked = true;
          applyType(checked);
        }
        setReference(reference);
      });
    });
  }

  const initAll = (scope) => {
    const target = scope || document;
    target.querySelectorAll('[data-pa-quote]').forEach(initQuote);
    target.querySelectorAll('[data-pa-quote-file]').forEach(initQuoteFile);
  };

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
